import React, { FC, useMemo, useRef, useState } from 'react';

import { Button } from 'devextreme-react/button';
import DataGrid, {
  Column,
  Export,
  FilterPanel,
  FilterRow,
  HeaderFilter,
  Pager,
  Paging,
  StateStoring,
} from 'devextreme-react/data-grid';
import 'devextreme-react/text-area';

import { AppCard, AppLayoutTop } from 'components/appComponents';
import ClaimsProvider from 'components/claimsBlock';
import { MONEY_FORMAT } from 'constants/formats';
import $createStore from 'utils/create-store-instance';
import { onExporting } from 'utils/exportingExcel';

import { CreateEditModal, DeleteModal } from './components';

type Props = {
  cashFlowId: number | string;
  refreshForm: () => void;
};

const ChangeCashFlowExpenseByDateDetail: FC<Props> = ({ cashFlowId, refreshForm }) => {
  const refGrid = useRef<DataGrid | null>(null);

  const [modalIsVisible, setModalIsVisible] = useState(false);
  const [modalIsVisibleDelete, setModalIsVisibleDelete] = useState(false);
  const [detailId, setDetailId] = useState<number | null>(null);

  const dataSource: any = useMemo(() => {
    return $createStore(`/v1/cashFlowExpenseByDate/${cashFlowId}/details`, 'id');
  }, [cashFlowId]);

  const refresh = () => {
    refGrid.current?.instance.refresh();
    refreshForm();
  };

  return (
    <div className="container-dev">
      <div className="pr-2 pt-1">
        <AppLayoutTop title="">
          <ClaimsProvider claimsBlock={['CanCreateExpenseByDateDetails']}>
            <Button
              width={120}
              text="Добавить"
              type="default"
              onClick={() => {
                setDetailId(null);
                setModalIsVisible(true);
              }}
            />
          </ClaimsProvider>
        </AppLayoutTop>
      </div>
      {modalIsVisible && (
        <CreateEditModal
          changeVisible={setModalIsVisible}
          id={detailId}
          refresh={refresh}
          visible={modalIsVisible}
          cashFlowId={+cashFlowId}
        />
      )}

      {modalIsVisibleDelete && (
        <DeleteModal
          changeVisible={setModalIsVisibleDelete}
          visible={modalIsVisibleDelete}
          refresh={refresh}
          detailId={detailId}
          cashFlowId={+cashFlowId}
        />
      )}

      <AppCard>
        <DataGrid
          dataSource={dataSource}
          showBorders={false}
          loadPanel={{
            enabled: true,
            text: 'Загрузка',
          }}
          ref={refGrid}
          remoteOperations={true}
          onExporting={onExporting}
          allowColumnResizing
          columnResizingMode="nextColumn"
          columnMinWidth={50}
          allowColumnReordering
        >
          <StateStoring enabled={true} type="localStorage" storageKey="ChangeCashFlowExpenseByDateDetail" />
          <Export enabled={true} />
          <FilterRow visible={true} />
          <FilterPanel visible={true} />
          <HeaderFilter visible />
          <Column dataField="cashFlowItemName" caption="Статья движения ДС" />
          <Column dataField="sum" caption="Сумма руб." format={MONEY_FORMAT} />
          <Column dataField="comment" caption="Комментарий" />
          <Column
            dataField="actions"
            caption=""
            width={120}
            allowFiltering={false}
            allowSorting={false}
            cellRender={(data) => (
              <>
                <ClaimsProvider claimsBlock={['CanEditExpenseByDateDetails']}>
                  <Button
                    icon="edit"
                    type="default"
                    stylingMode="text"
                    onClick={() => {
                      setDetailId(data.data.id);
                      setModalIsVisible(true);
                    }}
                  />
                </ClaimsProvider>
                <ClaimsProvider claimsBlock={['CanDeleteExpenseByDateDetails']}>
                  <Button
                    icon="trash"
                    type="default"
                    stylingMode="text"
                    onClick={() => {
                      setDetailId(data.data.id);
                      setModalIsVisibleDelete(true);
                    }}
                  />
                </ClaimsProvider>
              </>
            )}
          />

          <Paging defaultPageSize={15} />
          <Pager showPageSizeSelector={true} allowedPageSizes={[15, 30, 50, 100]} />
        </DataGrid>
      </AppCard>
    </div>
  );
};

export default ChangeCashFlowExpenseByDateDetail;
